import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';

import { SelectItem } from 'primeng/primeng';

import { Filter } from '../../shared/filter';
import { HttpErrorHandler } from '../../shared/http-error-handler';
import { NotificationsService } from '../../_services/notifications.service';

import { Ship } from '../../_models/ship';
import { ShipService } from '../../_services/ship.service';

import { Specie } from '../../_models/specie';
import { SpecieService } from '../../_services/specie.service';

import { ExportFilter } from '../../_models/export';
import { ExportDataService } from '../../_services/export-data.service';

@Component({
  selector: 'app-export-filter',
  templateUrl: './export-filter.component.html',
  styleUrls: ['./export-filter.component.css'],
})
export class ExportFilterComponent extends Filter implements OnInit {
  @Input() filterParams: any[] = [];
  @Output() onApplyFilter = new EventEmitter<string>();

  form: FormGroup;
  filter: ExportFilter;

  ships: SelectItem[];
  selectedShips: Ship[];
  species: SelectItem[] = [];
  selectedSpecies: Specie[] = [];

  startDate: Date;
  endDate: Date;

  constructor(
    private fb: FormBuilder,
    private shipService: ShipService,
    private specieService: SpecieService,
    private exportService: ExportDataService,
    private router: Router,
    protected notificationsService: NotificationsService,
    private httpErrorHandler: HttpErrorHandler
  ) {
    super();
    this.form = fb.group({
      code: [''],
      specie: [''],
      ship: [''],
      start_date: [''],
      end_date: [''],
    });
  }

  ngOnInit() {
    this.filter = new ExportFilter(this.filterParams);

    if (this.filter.start_date) {
      this.startDate = new Date(this.filter.start_date);
    }

    if (this.filter.end_date) {
      this.endDate = new Date(this.filter.end_date);
    }

    this.getShips();
    this.getSpecies();
  }

  getShips() {
    this.getCollection(this.shipService, Ship).then((ships: any[]) => {
      this.ships = this.parseDropdownResults(ships, new Ship(), 'name', false);
      this.selectedShips = this.selectMultipleDropdownItems(ships, this.filter.ship);
    });
  }

  getSpecies() {
    this.specieService.get_species_association().subscribe((response) => {
      this.species = this.parseDropdownResults(response, new Specie(), '_label', false);
      this.selectedSpecies = this.selectMultipleDropdownItems(response, this.filter.specie);
    });
  }

  onSubmit(event) {
    event.preventDefault();
    this.filter.reset();

    this.filter.specie = [];
    if (this.selectedSpecies) {
      this.filter.specie = this.selectedSpecies;
    }

    this.filter.ship = [];
    if (this.selectedShips.length > 0) {
      this.filter.ship = this.selectedShips;
    }

    if (this.startDate) {
      this.startDate.setHours(23);
      this.filter.start_date = this.startDate.toISOString().substring(0, 10);
    }

    if (this.endDate) {
      this.endDate.setHours(23);
      this.filter.end_date = this.endDate.toISOString().substring(0, 10);
    }

    let params = ExportFilter.serializeRouterParams(this.filter);
    params = this.filter.serializeQueryParams(params);
    this.applyFilter(params);
  }

  protected applyFilter(params) {
    this.onApplyFilter.emit(params);
  }

  exportToExcel(filterParams) {
    this.exportService.exportToExcel().subscribe(
      (response) => {
        this.exportService.downloadExcel(response.token, filterParams, []);
      },
      (error) => {
        const msg = this.httpErrorHandler.handleHttpError(error)[0];
        this.notificationsService.notify('error', 'Error', msg);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/export/export-filter/export-filter.component.ts